module.exports = __webpack_public_path__ + "static/media/warningCircle.bb05c929.svg";